






























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getExtensionPackage } from '@/api/school';
import { TExtensionPackage } from '@/types/views/school.d.ts'
@Component({})
export default class Marketing extends Vue {
  private multipleSelection = [];
  private extensionPackage: TExtensionPackage[] = [];
  private mounted() {
    this.getExtensionPackage();
  }
  /**
   * 下载文件
   */
  private downloadAll() {
    this.$message.success('正在批量下载');
    this.multipleSelection.map((item: any) => {
      setTimeout(() => {
        (document.querySelector('#myFrame') as any).src = item.url;
      }, 100);
    });
  }
  /**
   * 标识选中项
   * @param {any} val 选中项
   */
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  /**
   * 渲染index
   * @param {number} idx 索引
   */
  indexMethod(idx: number) {
    return idx + 1;
  }
  /**
   * 获取市场拓展包
   */
  private async getExtensionPackage() {
    try {
      const res: any = await getExtensionPackage();
      this.extensionPackage = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
